import { Component } from '@angular/core';
import { SibeBarComponent } from './sibe-bar/sibe-bar.component';
import { ProfilBarComponent } from './profil-bar/profil-bar.component';
import { FooterComponent } from './footer/footer.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
@Component({
  selector: 'app-portal',
  standalone: true,
  imports: [CommonModule, RouterModule, ProfilBarComponent, SibeBarComponent, FooterComponent],
  templateUrl: './portal.component.html',
  styleUrl: './portal.component.css'
})
export class PortalComponent {

}
